import {normalizeLanguage,DEFAULT_LANGUAGE} from './languages';

// Presentation-only amounts. These values must never be passed to order APIs.
export function usesUsdDisplay(language){return normalizeLanguage(language)!==DEFAULT_LANGUAGE;}
export function usdMinorFromGoldbase(goldbase){
 if(!Number.isSafeInteger(goldbase)||goldbase<=0||goldbase>Math.floor(Number.MAX_SAFE_INTEGER/2))return null;
 return goldbase*2; // 50 goldbase = USD 1; bonus/free/paid splits are irrelevant here.
}
export function formatUsdGoldbase(goldbase){
 const minor=usdMinorFromGoldbase(goldbase);
 if(minor===null)return null;
 const digits=String(minor).padStart(3,'0');
 return 'US$'+digits.slice(0,-2).replace(/\B(?=(\d{3})+(?!\d))/g,',')+'.'+digits.slice(-2);
}
export function displayGoldbase(product){
 if(!product||typeof product!=='object'||Array.isArray(product))return null;
 const offer=product.cmsOffer===undefined?product:product.cmsOffer;
 return offer&&usdMinorFromGoldbase(offer.goldbase)!==null?offer.goldbase:null;
}
export function actualChargeLabel(amountMinor,currency){
 // This is a display formatter, not currency conversion or payment validation.
 if(!['CNY','HKD'].includes(currency))return null;
 const text=typeof amountMinor==='number'&&Number.isSafeInteger(amountMinor)?String(amountMinor):amountMinor;
 if(typeof text!=='string'||!/^[1-9][0-9]{0,14}$/.test(text)||!Number.isSafeInteger(Number(text)))return null;
 const digits=text.padStart(3,'0');
 return currency+' '+digits.slice(0,-2).replace(/\B(?=(\d{3})+(?!\d))/g,',')+'.'+digits.slice(-2);
}

export function displayMinorFromMajor(amount){
 // Preserve decimal digits from an existing display quote; never round/reprice it.
 if(typeof amount!=='number'||!Number.isFinite(amount))return null;
 const match=/^([0-9]+)(?:\.([0-9]{1,2}))?$/.exec(String(amount));
 if(!match)return null;
 const minor=Number(match[1]+(match[2]||'').padEnd(2,'0'));
 return Number.isSafeInteger(minor)&&minor>0?minor:null;
}
